/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as SurveyQuestionDataTypeService} from "../../../Services/SurveyQuestionDataTypeService";

export class SurveyQuestionDataTypeFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			surveyQuestionDataTypes: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		SurveyQuestionDataTypeService.Get()
			.then((x) => {
				this.setState({surveyQuestionDataTypes: x.result});
			});
	}

	@autobind
	getSurveyQuestionDataType() {
		return this.state.surveyQuestionDataTypes.find((x) => x.surveyQuestionDataTypeId == this.props.Value);
	}

	@autobind
	_render() {
		return this.getSurveyQuestionDataType() ? this.getSurveyQuestionDataType().name : "N/A";
	}
}